/**
 * Where the /b/ WorkDetails screen sends the tenant after a successful `user/work-details`
 * answer. Pure (no React, no router) so it runs under `node --test`.
 *
 * - `eligible === false` (strictly): the server's credit checks left this tenant with no way to
 *   continue, so it already marked them not eligible and locked the bank-statement step. Land on
 *   the partner's not-eligible screen instead of banking. The server sends the field ONLY in that
 *   case (cpcore user.service addWorkDetails), so every other answer is untouched.
 * - `creditPath === "WITHOUT_BANKING"`: banking is already done server-side → "congrats"
 *   (Congrats handles the per-partner rules).
 * - anything else: the partner's `fromWorkDetailsTo`, else the default's — exactly as before.
 *
 * @param {object | null | undefined} res  the parsed work-details response
 * @param {string | null | undefined} partner  the partner tag from the URL
 * @param {Record<string, Record<string, string>>} rules  `navigationRules` (partnerJourney.jsx)
 * @returns {string} the next `step` query value
 */
export function workDetailsNextStep(res, partner, rules) {
  const own = (partner && rules?.[partner]) || undefined;
  if (res?.eligible === false) {
    return own?.notHardEligible || rules.default.notHardEligible;
  }
  if (res?.creditPath === "WITHOUT_BANKING") return "congrats";
  return own?.fromWorkDetailsTo || rules.default.fromWorkDetailsTo;
}
